<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="page_xv"></a>
<p class="fmtitle">List of Maps</p>
<p class="leaf1"><img alt="images" height="9" src="images/leaf.jpg" width="28"/></p>
<p class="map"><a href="#/10_Part01#img1">Eskdale, Scotland in 1780</a></p>
<p class="map"><a href="#/12_Part02#img2">South India in 1783</a></p>
<p class="map"><a href="#/15_Chapter04#img68">Hyderabad in October 1798</a></p>
<p class="map"><a href="#/15_Chapter04#img76">The Seringapatam Campaign, 1799</a></p>
<p class="map"><span href="#/18_Chapter06#img98" title="Link target outside of Sample">Persia and the Gulf, 1800–1810</span></p>
<p class="map"><span href="#/23_Chapter11#img158" title="Link target outside of Sample">War in the Deccan, 1803</span></p>
<p class="map"><span href="#/24_Chapter12#img176" title="Link target outside of Sample">India in 1805</span></p>
<p class="map"><span href="#/26_Chapter14#img214" title="Link target outside of Sample">The Pursuit of Holkar, 1805–6</span></p>
<p class="map"><span href="#/38_Chapter24#img384" title="Link target outside of Sample">The Battle of Mehidpoor, 21 December 1817</span></p>
<p class="map"><span href="#/39_Chapter25#img400" title="Link target outside of Sample">India in 1818</span></p>
<p class="map"><span href="#/40_Chapter26#img414" title="Link target outside of Sample">Central India, 1818–1821</span></p>
<p class="map"><span href="#/43_Chapter28#img456" title="Link target outside of Sample">Bombay to London: Malcolm’s overland route in 1821–2</span></p>
<a id="page_xvi"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Maps.vue?5ec6727b